import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchNotifications, updateNotifications } from '../../../store/notification/action';
import MyNotifications from './component';

const mapStateToProps = ({ notification, user }) => ({
    notification, user
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchNotificationsConnect: fetchNotifications,
    updateNotificationsConnect: updateNotifications,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MyNotifications);